// extracted by mini-css-extract-plugin
module.exports = {"usp":"ProductUsp_usp__nrcfQ","icon":"ProductUsp_icon__WgmhM","muted":"ProductUsp_muted__OYJFi"};